import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    paperHeader: {
      justifyContent: 'space-between'
    },
    justifyLeft: {
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    justifyRight: {
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    withMarginLeft: {
      marginLeft: theme.spacing(1)
    }
  });
});
